export function show(companyId)
{
    return axios.get(route('api.manage.companies.show', { company: companyId }));
}

export function update(companyId, data)
{
    return axios.patch(route('api.manage.companies.update', { company: companyId }), data)
        .then(response => response.data);
}

export function updatePlan(companyId, data)
{
    return axios.patch(route('api.manage.companies.updatePlan', { company: companyId }) + '?include=invoices', data)
        .then(response => response.data);
}

export function linkOfficient(companyId, data)
{
    return axios.post(route('api.manage.companies.linkOfficient', { company: companyId }), data)
        .then(response => response.data);
}

export function price(companyId, slots, frequency)
{
    return axios.get(route('api.manage.companies.price', { company: companyId }) + `?slots=${slots}&frequency=${frequency}`)
        .then(response => response.data);
}

export function applicationForm(companyId)
{
    return axios.get(route('api.manage.companies.application-form.index', { company: companyId }))
        .then(({data}) => data)
}

export function updateApplicationForm(companyId, data) {
    return axios
        .patch(route('api.manage.companies.application-form.updateOrCreate', { company: companyId }), data)
        .then(({ data }) => data);
}

export function force2fa() {
    return axios.get(route('api.manage.companies.force-2fa.get'));
}

export function updateForce2fa(data) {
    return axios.patch(route('api.manage.companies.force-2fa.update'), data);
}

export function hasDemoData() {
    return axios.get(route('api.manage.companies.has-demo-data'))
        .then(({data}) => data);
}
